import { buildTheme, buildThemeOptions } from "./buildTheme";
import { forestAgencyPreset } from "./presets";

// Use forest-agency preset tokens as the default theme
const agencyTokens = forestAgencyPreset.variants.light.tokens;

export const forestTheme = buildTheme(agencyTokens);
export const forestThemeOptions = buildThemeOptions(agencyTokens);

// Re-export theme builders
export { buildTheme, buildThemeOptions };

export * from "./tokens";

// Preset system
export { getPreset, registerPreset, getAvailablePresets, forestExternalPreset, forestAgencyPreset, forestInternalPreset, forestAlkemyPlusPreset } from "./presets";
export type { DesignTokens, PresetVariantConfig, ThemePreset } from "./types";
